import { useMemo } from "react";
import CustomForm from "../../common/components/CustomForm";
import useClientConfig from "../../common/hooks/clientConfigHook"
import { cleanFormDef } from "../../common/utils/formUtilities";

const ExpressionOfInterestEditor = ({ eoi, isPublic, disabled, onChange }) => {
    const clientConfig = useClientConfig();

    const def = useMemo(() => {
        let toReturn = clientConfig.expressionOfInterest?.form;
        if (toReturn && isPublic) {
            toReturn = cleanFormDef(toReturn, col => !col.restricted);
        }
        return toReturn ?? [];
    }, [clientConfig.expressionOfInterest?.form, isPublic])

    return <CustomForm def={def} data={eoi?.data ?? {}} onChange={data => onChange('data', data)} required disabled={disabled}></CustomForm>
}

export default ExpressionOfInterestEditor;